const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const CopyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const DOCUMENT_TYPE_LABELS = {
  FACTURA: 'Invoice',
  NOTA_DE_CREDITO: 'Credit Note',
  NOTA_DE_DEBITO: 'Debit Note',
  REMITO: 'Delivery Note',
  RECIBO: 'Receipt',
  LIQUIDACION: 'Settlement',
  OTRO: 'Other',
};

export function ClassifyResult({ data }) {
  const classifyData = data.classification || data;

  const { document_type, sub_type, confidence, is_afip, language } = classifyData;

  const confidencePct = confidence != null ? Math.round(confidence * 100) : null;

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(classifyData, null, 2));
  };

  const handleDownload = () => {
    const blob = new Blob([JSON.stringify(classifyData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `classification-${document_type || 'result'}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="result-card-wrapper">
      <div className="result-card-header">
        <span>Classification Result</span>
        <div className="result-card-actions">
          <button className="btn-action" onClick={handleDownload}>
            <DownloadIcon />
            Download
          </button>
          <button className="btn-action" onClick={handleCopy}>
            <CopyIcon />
            Copy
          </button>
        </div>
      </div>

      <div className="result-card-body">
        <div className="result-fields-title">Document classification</div>
        <div className="result-fields-grid">
          <div className="result-field">
            <span className="result-field-label">DOCUMENT TYPE</span>
            <span className="result-field-value">
              {DOCUMENT_TYPE_LABELS[document_type] || document_type || '-'}
            </span>
          </div>
          <div className="result-field">
            <span className="result-field-label">SUB-TYPE</span>
            <span className="result-field-value">{sub_type ?? '-'}</span>
          </div>
          <div className="result-field">
            <span className="result-field-label">CONFIDENCE</span>
            <span className="result-field-value">
              {confidencePct != null ? `${confidencePct}%` : '-'}
            </span>
          </div>
          <div className="result-field">
            <span className="result-field-label">AFIP OFFICIAL</span>
            <span className="result-field-value">
              {is_afip === true ? 'Yes' : is_afip === false ? 'No' : '-'}
            </span>
          </div>
          <div className="result-field">
            <span className="result-field-label">LANGUAGE</span>
            <span className="result-field-value">{language?.toUpperCase() ?? '-'}</span>
          </div>
        </div>
      </div>

      <div className="result-card-footer">
        <span className="result-model-info">
          Model: <span>surus-classify-ainode</span>
        </span>
      </div>
    </div>
  );
}
